import { defineMessages } from 'react-intl-next';

export default defineMessages({
	iconLabel: {
		id: 'team-button-trigger.icon.label',
		defaultMessage: 'Team button',
		description: 'Label for the team button icon',
	},
	addTeamIconLabel: {
		id: 'team-button-trigger.add-team-icon.label',
		defaultMessage: 'Add team',
		description: 'Label for the add team icon',
	},
});
